import "./sentry";
import { AnalyticsProvider } from "@piiqtechnologies/ui-lib";
import { analytics } from "./analytics-setup";
import React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
ReactDOM.render(React.createElement(AnalyticsProvider, { instance: analytics },
    React.createElement(App, null)), document.getElementById("root"));
